import React from 'react';
import colors from 'src/style/colors';
import { Paragraph, SubtitleDescription } from '../Typography';
import { Avatar } from '../Avatars';
import { mediaQueries } from 'src/style/breakpoints';

const ReviewCardSmall = ({ avatar, title, text, author }) => {
  return (
    <div
      css={{
        padding: 15,
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
        backgroundColor: colors.lightGrey,
        borderRadius: 5,
        width: 'calc((100% - 20px)/3)',
        boxShadow: 'rgba(0, 0, 0, 0.08) 0px 3px 10px',
        marginBotton: 10,
      }}
    >
      {avatar === false ? null : (
        <div
          css={{
            position: 'absolute',
            top: '-55px',
            zIndex: 1,
            [mediaQueries.tabletPortraitUp]: {
              top: '-65px',
            },
          }}
        >
          <Avatar name={avatar} big={true} alt={`photographie de ${author}`} />
        </div>
      )}
      <SubtitleDescription
        css={{
          alignSelf: 'center',
          padding: '0 0 10px 0',
          paddingTop: avatar === false ? 30 : 75,
          [mediaQueries.tabletPortraitUp]: {
            paddingTop: 50,
          },
        }}
      >
        {author}
      </SubtitleDescription>
      <Paragraph
        css={{
          color: colors.purple,
          fontWeight: 'bold',
          textAlign: 'center',
          padding: '0 0 10px 0',
          paddingTop: 10,
        }}
      >
        {title}
      </Paragraph>
      <Paragraph
        css={{
          color: colors.purpleDark,
          fontStyle: 'italic',
          padding: '10px',
          textAlign: 'center',
          [mediaQueries.phoneOnly]: {
            fontSize: 16,
            lineHeight: '22px',
          },
          [mediaQueries.tabletPortraitUp]: {
            fontSize: 18,
            lineHeight: '27px',
            padding: '10px',
          },
        }}
      >
        {text}
      </Paragraph>
    </div>
  );
};

export default ReviewCardSmall;
